import { Badge } from "@/ui/components/primitives/badge";
import { cn } from "@/ui/components/primitives/utils";

interface PSPStatusBadgeProps {
  isEnabled: boolean;
  isSandbox?: boolean;
  className?: string;
}

export function PSPStatusBadge({ isEnabled, isSandbox, className }: PSPStatusBadgeProps) {
  if (isSandbox) {
    return (
      <Badge
        className={cn(
          "bg-yellow-500/10 text-yellow-700 border-yellow-500/20 dark:text-yellow-400",
          className
        )}
      >
        Sandbox
      </Badge>
    );
  }

  if (isEnabled) {
    return (
      <Badge
        className={cn(
          "bg-green-500/10 text-green-700 border-green-500/20 dark:text-green-400",
          className
        )}
      >
        Enabled
      </Badge>
    );
  }

  return (
    <Badge
      className={cn(
        "bg-gray-500/10 text-gray-700 border-gray-500/20 dark:text-gray-400",
        className
      )}
      variant="secondary"
    >
      Disabled
    </Badge>
  );
}

interface PSPTypeBadgeProps {
  type: "PAYIN" | "PAYOUT" | "BOTH";
  className?: string;
}

export function PSPTypeBadge({ type, className }: PSPTypeBadgeProps) {
  const variants = {
    PAYIN: "bg-blue-500/10 text-blue-700 border-blue-500/20 dark:text-blue-400",
    PAYOUT: "bg-purple-500/10 text-purple-700 border-purple-500/20 dark:text-purple-400",
    BOTH: "bg-indigo-500/10 text-indigo-700 border-indigo-500/20 dark:text-indigo-400",
  };

  return (
    <Badge className={cn(variants[type], className)}>
      {type}
    </Badge>
  );
}

interface ProviderBadgeProps {
  provider: string;
  className?: string;
}

export function ProviderBadge({ provider, className }: ProviderBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn("font-mono text-xs", className)}
    >
      {provider}
    </Badge>
  );
}
